import { userList, userPatch } from "@/api/user";
const state = {
    userData: {},
};

const mutations = {
    SET_USER_DATA(state, data) {
        state.userData = data;
    },
};

const actions = {
    async fetchUserData({ commit }) {
        try {
            const response = await userList();
            if (response && response.success) {
                commit("SET_USER_DATA", response.body);
            } else {
                console.error("获取用户数据失败");
            }
        } catch (error) {
            console.error("获取用户数据时出错：", error);
        }
    },
    async updateUserData({ commit }, updatedData) {
        try {
            const response = await userPatch(updatedData);
            console.log(response.body, '更新');
            if (response && response.success) {
                commit("SET_USER_DATA", response.body);
                return true;
            } else {
                console.error("更新用户数据失败");
                return false;
            }
        } catch (error) {
            console.error("更新用户数据时出错：", error);
            return false;
        }
    },
};
const getters = {
    userData: (state) => {
        if (state.userData.avatar_url) {
            state.userData.avatar_url = `${state.userData.avatar_url}?t=${new Date().getTime()}`;
        }
        return state.userData;
    },
};


export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};